// :cow: Cosmose CONFIDENTIAL :iso:
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, STATE_NAME_SELECT_MEDIA_GROUPS } from './select-media-group.reducer';

const currentState = createFeatureSelector<State>(STATE_NAME_SELECT_MEDIA_GROUPS);

export const selectCategoryListResponse = createSelector(
  currentState,
  (state: State) => (state.response || []).map((item: string) => ({value: item, label: item})),
);

export const selectMediaGroupsListRawResponse = createSelector(
  currentState,
  (state: State) => state.response,
);

export const selectCategoryListError = createSelector(
  currentState,
  (state: State) => state.responseError,
);

export const selectCategoryListShowSkeleton = createSelector(
  currentState,
  (state: State) => state.responseLoading,
);


